import React, { useCallback, useEffect, useMemo, useState } from "react";
import {Col,Form,Row} from "react-bootstrap";
import "rsuite/dist/rsuite.min.css";
import { useDispatch, useSelector } from "react-redux";
import { FaTrash } from "react-icons/fa6";
import { InputGroup } from "react-bootstrap";
import CurrencyFormat from "react-currency-format";
import { clientProjectOptions } from "jsFunctions/clientProjectOptions";
import { fetchAsyncGetVendorByID } from "redux/vendorSlice";
import ClientProjectSelect from "components/ClientProjectSelect";
import { Box } from "@chakra-ui/react";
import { currencyFormate } from "jsFunctions/helperFunctions";
import CustomPopover from "components/customPopover/customPopover";
import useOrganizationData from "hooks/organizaton/useOrganization";
import DrawerButton from "./component/buttons/drawerButton";


const GstInfoComponent = ({ getData, autoCount,gstAmountError,merchantValue,deleteMultipleGstItem, gstData,taxableAmount, expenseType, role}) => {
    const [addTogglePaymentIdx, setAddTogglePaymentIdx] = useState(true);
    const [gstType, setGstType] = useState("");
    const [gstPercentage, setGstPercentage] = useState(0);
    const [baseAmount, setBaseAmount] = useState("");
    const [companyTypeValue, setCompanyTypeValue] = useState([]);
    const [gstNumber, setGstNumber] = useState("");
    const [allGst,setAllGst] = useState([])
    const [amt , setAmt] = useState({
      c:'',
      s:'',
      i:''
    })
  const dispatch = useDispatch(); 
  const vendorList = useSelector((state) => state.vendorData);
  const {organizationData} = useOrganizationData();


  const companyTypeOption = useMemo(() => {
    const filteredVendors = expenseType === "resource"
      ? vendorList.filter(vendor => vendor.isC === true)
      : vendorList.filter(vendor => vendor.isV === true);
    return clientProjectOptions('name', '_id', filteredVendors);
  }, [vendorList, expenseType]);


  const handleOnChange = async(baseAmt,company)=>{
    const data = {
        bsAmt: baseAmt,
        vId: company,
        gstNo:gstNumber,
        prc: gstPercentage,
        amt: {
          c: amt?.c,
          s: amt?.s,
          i: amt?.i

        },
      };
      getData(data);
    }


  const getCompanyByID = async (id) => {
  try {
    const res = await dispatch(fetchAsyncGetVendorByID(id));
    if (res?.payload) {
      const vendor = res.payload.vendor;
      const setData = {
        label: vendor.name,
        value: vendor._id,
      };
      setCompanyTypeValue(setData);
      if (vendor?.gsts) {
        const gstNumbers = vendor.gsts.map(gst => gst.gstNo);
        setAllGst(gstNumbers);
      }
    }
  } catch (err) {
    console.error(err);
  }
};
  useEffect(()=>{
    if(gstData?._id){

      const {vId,amt,gstNo,bsAmt, prc} = gstData?._id;
        if(vId){
          getCompanyByID(vId)
        }
        setGstNumber(gstNo)
        setBaseAmount(bsAmt)
        setGstPercentage(prc)
        setAmt(amt)
    }
    else{
      handleOnChange(taxableAmount,merchantValue)
      setBaseAmount(taxableAmount)
      if(merchantValue && merchantValue?.value){
        getCompanyByID(merchantValue?.value)
      }
    } 

  },[gstData?._id,taxableAmount,merchantValue])


  useEffect(() => {
    if (gstNumber && organizationData?._id) {
      const stateCode = gstNumber.substring(0, 2);
      const gstCode = organizationData?.gstNo;
      const organizationStateCode = gstCode?.substring(0, 2);
      const gstType = stateCode === organizationStateCode ? 'SGST' : 'IGST';
      setGstType(gstType);
      calculateGstAmount(gstType, gstPercentage);
    } else {
      setGstType('IGST');
      calculateGstAmount('IGST', gstPercentage);
    }
  }, [gstNumber, organizationData]);
  
  useEffect(()=>{
    if(gstPercentage && gstType){
      calculateGstAmount(gstType, gstPercentage);
    }
  },[baseAmount])

   


    const isValidObjectId = (id) => {
      return /^[a-f0-9]{24}$/.test(id);
  };
  useEffect(() => {
    if (companyTypeValue?.value && isValidObjectId(companyTypeValue.value)) {
      const id = companyTypeValue.value;
      dispatch(fetchAsyncGetVendorByID(id))
        .then((res) => {
          if (res?.payload) {
            const vendor = res.payload.vendor;
            if (vendor?.gsts?.length) {
              const gstNumbers = vendor.gsts.map(gst => gst.gstNo);
              setAllGst(gstNumbers);
            }
            if (gstData?._id) {
              const { vId, gstNo } = gstData._id;
              setGstNumber(vId !== id ? "" : gstNo);
            }
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }, [companyTypeValue]);

  const calculateGstAmount = (type, percentage) => {
    const baseAmt = Number(baseAmount);
    if (baseAmt && percentage) {
      const gstValue = (baseAmt * percentage) / 100;
      let newGstAmount = { c: 0, s: 0, i: 0 };
      if (type === "CGST" || type === "SGST") {
        newGstAmount.c = newGstAmount.s = Number(gstValue / 2).toFixed(2);
      } else if (type === "IGST") {
        newGstAmount.i = gstValue;
      }
      setAmt(newGstAmount);
      const data = {
        bsAmt: baseAmt,
        vId: companyTypeValue,
        gstNo:gstNumber,
        prc: percentage,
        amt: newGstAmount
      };
      getData(data);
    }
  };

  const calculateTotalGST = useCallback(() => {
    if (gstType === 'IGST') {
      return Number(amt?.i) || 0; 
    } else {
      return (Number(amt?.s) || 0) + (Number(amt?.c) || 0); 
    }
  }, [gstType, amt]);

  return (
    <div
      className={`payment-listing_box ${addTogglePaymentIdx ? "show" : "hide"}`}
    >
      <div className="payment-list_array">
        <div className="d-flex">
        <span className="payment-details">GST Details {autoCount + 1}</span>
        <span className="amountSpan">
          {baseAmount ? currencyFormate(Number(baseAmount)) : 0}
          </span>
        </div>
        <div
          className="d-flex toggleImage-content"
          
        >
          {baseAmount &&
          
          <div className="total_gst_amount">
          <span>
            {currencyFormate(Number(baseAmount || 0) + Number(calculateTotalGST()))}
          </span>
            <CustomPopover popoverText="Base Amount + Total GST" />
          </div>
          }
          <DrawerButton
            isOpen={addTogglePaymentIdx}
            handleClick={() => {
              setAddTogglePaymentIdx(!addTogglePaymentIdx);
            }}
          />
        </div>
        {["Admin", "Manager", "Accountant"].includes(role) && (
          <div className="d-flex" onClick={() => deleteMultipleGstItem()}>
            <span>
              <FaTrash
                style={{
                  fontSize: "16px",
                  color: "red",
                  cursor: "pointer",
                }}
              />
            </span>
          </div>
        )}
      </div>
      <div
        className={`payment-inner_box mb-4 ${
          addTogglePaymentIdx ? "show-content" : "hide-content"
        }`}
      >
        <Row>
          <Col>
          <Box display="flex" className="input-box" >

            <Form.Label>Base Amount  <span className="span-star">*</span></Form.Label>
            <Box>

            <InputGroup>
              <InputGroup.Text>
                <span className="rupee-symbol">₹</span>{" "}
              </InputGroup.Text>
              <CurrencyFormat
                customInput={Form.Control}
                type="text"
                onValueChange={(e) => {
                  handleOnChange(
                    e?.value,
                    companyTypeValue
                  );
                  setBaseAmount(e?.value);
                }}
                name="baseAmount"
                value={baseAmount || ""}
                defaultValue={baseAmount}
                thousandSeparator={true}
                decimalScale={2}
                fixedDecimalScale={true}
              />
            </InputGroup>

            </Box>
          </Box>
            {
            <p className="form_error"> {gstAmountError[`gst.${autoCount}.baseAmount`]}</p>
            }
          </Col>
          <Col></Col>
        </Row>
       
        <Row>
          <Col>
          <Box display="flex" className="input-box" >
            <Form.Label>Company Name  <span className="span-star">*</span></Form.Label>
            <Box>

            <ClientProjectSelect
              options={companyTypeOption}
              placeHolder={<div>Type or select...</div>}
              onChange={(newValue) => {
                handleOnChange(baseAmount, newValue);
                setCompanyTypeValue(newValue);
              }}
              isSearchable
             
              defaultValue={companyTypeValue}
              role={role}
            />

            </Box>
          </Box>

          {!companyTypeValue?.value &&
            <p className="form_error"> {gstAmountError[`gst.${autoCount}.companyId`]}</p>
          }
          
          </Col>
          <Col>
          <Box display="flex" className="input-box" >

            <Form.Label>GST Number  <span className="span-star">*</span></Form.Label>
            <Box>

            <Form.Select
                  className="custom--dropdown-container"
                  value={gstNumber}
                  onChange={(e) => {
                    // handleOnChange(
                    //   baseAmount,
                    //   companyTypeValue,
                    //   e.target.value,
                    //   amt
                    // );
                    setGstNumber(e.target.value);

                  }}
                >
                  <option value="">Select GST Number</option>
                  {allGst && allGst?.length > 0 && allGst?.map((gst)=>{
                    return (
                      <option value={gst}>{gst}</option>
                    )
                  })}
                  
                </Form.Select>

            </Box>
          </Box>
            {!gstNumber &&
            <p className="form_error"> {gstAmountError[`gst.${autoCount}.gstNumber`]}</p>
            }
          </Col>
        </Row>
        <Row>
          <Col>
          <Box display="flex" className="input-box" >
            <Form.Label>GST Type  <span className="span-star">*</span></Form.Label>
            <Box>

            <Form.Select
              className="custom--dropdown-container"
              value={gstType}
              onChange={(e) => {
                setGstType(e.target.value);
                calculateGstAmount(e.target.value, gstPercentage);
              }}
              style={{cursor:"not-allowed"}}
              disabled
            >
              <option value="">Select GST Type</option>
              <option value="IGST">IGST</option>
              <option value="SGST">SGST + CGST</option>
            </Form.Select>

            </Box>
            </Box>
            {!gstType &&
            <p className="form_error"> {gstAmountError[`gst.${autoCount}.gstType`]}</p>
            }
          </Col>
          <Col>
          <Box display="flex" className="input-box" >
            <Form.Label>GST Percentage (%)  <span className="span-star">*</span></Form.Label>
            <Box>

            <Form.Select
              className="custom--dropdown-container"
              value={gstPercentage}
              onChange={(e) => {
                const percentage = Number(e.target.value);
                setGstPercentage(percentage);
                calculateGstAmount(gstType, percentage);
              }}
            >
              <option value="0">0%</option>
              <option value="5">5%</option>
              <option value="12">12%</option>
              <option value="18">18%</option>
              <option value="28">28%</option>
            </Form.Select>

            </Box>
            </Box>
            {!gstPercentage &&
            <p className="form_error"> {gstAmountError[`gst.${autoCount}.gstPercentage`]}</p>
            }
          </Col>
        </Row>
        {gstType === 'IGST' &&
        
        <Row>
          <Col>
          <Box display="flex" className="input-box" >
            <Form.Label>IGST</Form.Label>
            <InputGroup>
              <InputGroup.Text>
                <span className="rupee-symbol">₹</span>{" "}
              </InputGroup.Text>
              <CurrencyFormat
                customInput={Form.Control}
                type="text"
                
                name="igst"
                value={amt?.i || ""}
                thousandSeparator={true}
                decimalScale={2}
                fixedDecimalScale={true}
                disabled
              />
            </InputGroup>
            
            
            </Box>
          </Col>
          <Col>
          <Box display="flex" className="input-box" >

            <Form.Label>Total GST</Form.Label>
            <InputGroup>
              <InputGroup.Text>
                <span className="rupee-symbol">₹</span>{" "}
              </InputGroup.Text>
              <CurrencyFormat
                customInput={Form.Control}
                type="text"
                name="total_gst"
                value={ gstType === 'IGST' ?  Number(amt?.i) :
               
                    Number(amt?.s) +
                    Number(amt?.c) || ""
                }
                thousandSeparator={true}
                decimalScale={2}
                fixedDecimalScale={true}
                disabled
              />
            </InputGroup>
          </Box>
          </Col>
         
        </Row>
        }
        {gstType === 'SGST' &&
        <>
        <Row>
          <Col>
          <Box display="flex" className="input-box" >

            <Form.Label>SGST</Form.Label>
            <InputGroup>
              <InputGroup.Text>
                <span className="rupee-symbol">₹</span>{" "}
              </InputGroup.Text>
              <CurrencyFormat
                customInput={Form.Control}
                name="sgst"
                type="text"
               
                value={amt?.s || ""}
                thousandSeparator={true}
                decimalScale={2}
                fixedDecimalScale={true}
                disabled
              />
            </InputGroup>
          </Box>
          </Col>
          
          <Col>
           <Box display="flex" className="input-box" >

            <Form.Label>CGST</Form.Label>
            <InputGroup>
              <InputGroup.Text>
                <span className="rupee-symbol">₹</span>{" "}
              </InputGroup.Text>
              <CurrencyFormat
                customInput={Form.Control}
                name="gst"
                type="text"
               
                value={amt?.c || ""}
                thousandSeparator={true}
                decimalScale={2}
                fixedDecimalScale={true}
                disabled
              />
            </InputGroup>
            </Box>
          </Col>
        </Row>
        <Row>
        <Col>
          <Box display="flex" className="input-box" >

            <Form.Label>Total GST</Form.Label>
            <InputGroup>
              <InputGroup.Text>
                <span className="rupee-symbol">₹</span>{" "}
              </InputGroup.Text>
              <CurrencyFormat
                customInput={Form.Control}
                type="text"
                name="total_gst"
                value={ gstType === 'IGST' ?  Number(amt?.i) :
               
                    Number(amt?.s) +
                    Number(amt?.c) || ""
                }
                thousandSeparator={true}
                decimalScale={2}
                fixedDecimalScale={true}
                disabled
              />
            </InputGroup>
          </Box>
          </Col>
          <Col></Col>
        </Row>
        </>
          }
      </div>
    </div>
  );
};

export default GstInfoComponent;
